export const DONE_BUTTON_TEXT = "Done";
export const DESKTOP_CALENDAR_TITLE_ROUND_TRIP =
  "Select the departure and arrival dates";
export const DESKTOP_CALENDAR_TITLE_ONE_WAY = "Select the departure date";
